const GET_CATEGORIES = 'GET_CATEGORIES';
const RENAME_CATEGORY = 'RENAME_CATEGORY';
const GET_WORKFLOW_TYPES = 'GET_WORKFLOW_TYPES';
const GET_WORKGROUPS = 'GET_WORKGROUPS';
const GET_PERMISSIONS = 'GET_PERMISSIONS';
const GET_WORKFLOWS_BY_CATEGORY = 'GET_WORKFLOWS_BY_CATEGORY';
const SELECT_CATEGORY = 'SELECT_CATEGORY';

export const TICKET_MGMT_TYPES = {
    GET_CATEGORIES,
    RENAME_CATEGORY,
    GET_WORKFLOW_TYPES,
    GET_WORKGROUPS,
    GET_PERMISSIONS,
    GET_WORKFLOWS_BY_CATEGORY,
    SELECT_CATEGORY
};
